/**
 * 去除小数点后多余的零
 * @param str "123.2000"
 */
export function removeDecimalZero<T>(str: T): T {
  if (typeof str === 'string') {
    const pointIndex = str.indexOf('.');
    if (pointIndex === -1) {
      return str;
    }
    const beforePointStr = str.slice(0, pointIndex);
    let afterPointStr = str.slice(pointIndex);
    afterPointStr = afterPointStr.replace(/\.?0+$/, '');
    return (beforePointStr + afterPointStr) as unknown as T;
  } else {
    return str;
  }
}
